import React from 'react';
import { Project } from '../../../Project/ProjectList';
import { Result } from '../../ResultList';
import { getModelNameFromPath } from '../../untilities/resultPath';

interface CompareHeading{
    currentProject: Project
    compareProject: Project
    result: Result
    resultCompare: Result
}

export default function ComapreHeading(props: CompareHeading){

    const { currentProject, compareProject, result, resultCompare } = props;

    const leftTitle = getModelNameFromPath(result?.model_path)
    const rightTitle = getModelNameFromPath(resultCompare?.model_path)

    return <div className='flex flex-row w-full p-2 text-center'>
        <div className='w-1/2'>{leftTitle}</div>
        <div className='w-1/2'>{rightTitle}</div>
    </div>
}